import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysParsingCase } from '../queryKeys';

import { bulkDismissParsingCases } from './bulkDismissParsingCases';
import { type BulkDismissParsingCasesMutationOptions } from './types';

/**
 * Dismiss multiple parsing cases and refresh parsing-case queries afterwards.
 *
 * @param options - Optional react-query mutation options
 * @returns The mutation result
 */
export function useMutationBulkDismissParsingCases(
  options?: BulkDismissParsingCasesMutationOptions,
) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: bulkDismissParsingCases,
    onSettled(data, error, variables, onMutateResult, context) {
      void queryClient.invalidateQueries({
        queryKey: [queryKeysParsingCase.base()],
      });
      return options?.onSettled?.(
        data,
        error,
        variables,
        onMutateResult,
        context,
      );
    },
  });
}
